import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';

interface Props {
    num: string;
    value: string;
    prevKey?: string;
    nextKey?: string;
}
export const Story: React.FC<Props> = ({ num, value, prevKey, nextKey }: Props) => {
    const [errorMessage, setErrorMessage] = useState<string>('');
    const dir: string = '/assets/';
    const pathFile = `${dir}${num}.txt`;
    const [txtContent, setTxtContent] = useState<JSX.Element>();
    const navigate = useNavigate();
    useEffect(() => {
        const fetchData = async () => { 
            try {
                const fetchFile = await fetch(pathFile);
                const txt = await fetchFile.text();
                // console.log("txt:", txt);

                    const paragraphs = txt.split('<br>');
                    const txtP = paragraphs.map((p, index) => <p className="story-p" key={index}>{p}</p>);

                setTxtContent(<>{txtP}</>);
            } catch (error: any) {
                setErrorMessage(error.message);

            }
        }

        fetchData()
    }, [num])

    function goOn (back: boolean) { 
        console.log("prev: ", prevKey);
        console.log("next: ", nextKey)
        back ? navigate(`/${prevKey}`) : navigate(`/${nextKey}`);
    }

    return (
    <div className="story-class">
        {errorMessage && <div>Hello, {errorMessage}</div>}
        {txtContent && <>
        <p className="story-header">&#9900; {value} &#9900;</p>
        <p className="story-content">{txtContent}</p></>}
        <nav className="back-forward">
            {prevKey && <div className="back-class" onClick={() => goOn(true)} title="Назад"><ArrowBackOutlinedIcon className="icon-class"/></div>}
            {!prevKey && <div />}
            {nextKey && <div className="forward-class" onClick={() => goOn(false)} title="Вперед"><ArrowForwardOutlinedIcon className="icon-class"/></div>}

        </nav>
    </div>
    )
}